/*!
 * TimelineView - Vue chronologique (timeline) temporelle avec jalons pour IconsView
 */

import CardView from './CardView';

export default class TimelineView extends CardView {
    constructor(plugin) {
        super(plugin, 'timeline');
        this.currentPeriod = null;
        this.itemIndex = 0;
    }

    createContainer(element) {
        const myself = this.plugin;
        this.currentPeriod = null;
        this.itemIndex = 0;

        this.container = $(`
            <div class="iv__timeline-wrapper">
                <div class="iv__timeline-spine"></div>
                <div class="iv__timeline-track iv__container"></div>
            </div>
        `);
        myself.container = this.container.find('.iv__timeline-track');

        myself.containerView.addClass('iv__view iv__view--timeline view view-timeline');
        element.append(this.container);

        if (myself.preview) {
            element.append(myself.preview);
        }

        return myself.container;
    }

    /**
     * Extrait et parse la date d'un élément
     * @param {Object} data
     * @returns {{ raw: string|null, date: Date|null, label: string }}
     */
    extractItemDate(data) {
        const myself = this.plugin;
        let rawDate = data.date;

        if (!rawDate && myself.getDateFields) {
            const dateFields = myself.getDateFields(data.type);
            if (dateFields && dateFields.length && data.data) {
                rawDate = data.data[dateFields[0]];
            }
        }

        if (!rawDate && data.data) {
            rawDate = data.data.date || data.data.created_at || data.data.datetime;
        }

        if (!rawDate) {
            rawDate = data.created_at || data.datetime;
        }

        if (Array.isArray(rawDate)) {
            rawDate = rawDate[0];
        }

        if (!rawDate) {
            return { raw: null, date: null, label: __('Sans date') };
        }

        let parsed = new Date(typeof rawDate === 'string' ? rawDate.replace(' ', 'T') : rawDate);
        if (isNaN(parsed.getTime())) {
            return { raw: String(rawDate), date: null, label: String(rawDate) };
        }

        const dateStr = parsed.toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });

        const timeStr = parsed.toLocaleTimeString('fr-FR', {
            hour: '2-digit',
            minute: '2-digit',
        });

        return {
            raw: rawDate,
            date: parsed,
            label: dateStr,
            time: (timeStr !== '00:00' && timeStr !== '01:00') ? timeStr : null,
            periodKey: parsed.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' }),
        };
    }

    renderIcon(data, container, subdir, path) {
        const myself = this.plugin;
        if (data.type === 'root') return true;

        myself.viewItemThumbsMode = false;
        const currentType = this.getTypes(data);
        const currentClassAll = this.buildItemClasses(data, currentType, (data.class || data.cls || ''));

        const timelineFields = myself.getViewFields('timeline') || myself.getViewFields('mosaic');
        const codeSubtext = this.buildFieldsSubtext(data, timelineFields);

        const timelineIconSize = myself.getViewIconSize('timeline') || 36;
        myself.viewThumbsHeight = timelineIconSize;
        myself.viewThumbsWidth = timelineIconSize;

        const dateInfo = this.extractItemDate(data);

        // Header de période (Mois / Année) si changement de période
        const targetContainer = container.hasClass('iv__timeline-track') ? container : this.container.find('.iv__timeline-track');
        if (dateInfo.periodKey && dateInfo.periodKey !== this.currentPeriod) {
            this.currentPeriod = dateInfo.periodKey;
            const $periodHeader = $(`
                <div class="iv__timeline-period">
                    <span class="iv__timeline-period__badge">${dateInfo.periodKey.toUpperCase()}</span>
                </div>
            `);
            targetContainer.append($periodHeader);
        }

        this.itemIndex++;
        const isAlternateRight = (this.itemIndex % 2 === 0);
        const sideClass = isAlternateRight ? 'iv__timeline-item--right' : 'iv__timeline-item--left';

        let countHtml = '';
        if (myself.shouldShowCount(data, 'timeline')) {
            countHtml = ' <span class="iv__item__count">(' + data.count + ')</span>';
        }

        const code = `
            <div class="${currentClassAll} iv__timeline-item ${sideClass}">
                <div class="iv__timeline-node">
                    <span class="iv__timeline-node__dot"></span>
                </div>
                <div class="iv__timeline-card iv__item__frame">
                    <div class="iv__timeline-card__header">
                        <span class="iv__timeline-card__date">${dateInfo.label}</span>
                        ${dateInfo.time ? '<span class="iv__timeline-card__time">' + dateInfo.time + '</span>' : ''}
                    </div>
                    <span class="iv__item__link">
                        <span class="iv__item__image">${myself.renderIconImage(timelineIconSize, data.icon, data, 'img')}</span>
                        <label class="iv__item__label">
                            <span class="iv__item__name titre">${data.label || ''}</span>
                            ${countHtml}
                            ${codeSubtext.length > 0 ? '<span class="iv__item__data infos">' + codeSubtext.join('') + '</span>' : ''}
                        </label>
                    </span>
                </div>
            </div>
        `;

        const currentIcon = $(code);
        targetContainer.append(currentIcon);

        this.attachItemEvents(currentIcon, currentIcon.find('.iv__timeline-card'), data, currentType, path);
        this.renderBadge(data, currentIcon);

        return currentIcon;
    }
}
